<template>
  <v-toolbar flat>
    <span class="checkboxDescription">表示するキャンペーン：</span>
    <div>
      <v-checkbox
        :key="index"
        v-for="(option, index) in selectOptions"
        :label="option.text"
        @change="onActiveFilterChange(option.value)"
        :input-value="searchAndFilter.activeFilter[option.value]"
        class="checkbox"
        hide-details
        messages="none"
      />
    </div>
    <v-select
      v-model="menuType"
      :items="menuTypeItems"
      class="select"
      hide-details
    />
    <v-spacer />
    <CampaignListSearchBox @onTextChange="onTextChange" class="search-box" />
    <PageSelect
      :value="campaignList"
      @input="pagination"
      style="width:200px;"
      class="pl-4"
    />
  </v-toolbar>
</template>

<script>
import { MenuTypes } from '@/models/Menu/Constants'
import CampaignListSearchBox from './CampaignListSearchBox.vue'
import PageSelect from '@/components/Shared/Search/PageSelect'

export default {
  name: 'CampaignsSearchAndFilter',
  components: {
    CampaignListSearchBox,
    PageSelect,
  },
  props: {
    searchAndFilter: {
      type: Object,
      default: () => {},
    },
    onActiveFilterChange: {
      type: Function,
      default: () => {},
    },
    onMenuTypeChange: {
      type: Function,
      default: () => {},
    },
    campaignList: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuTypeItems() {
      return [
        { value: null, text: '全てのメニュー種別' },
        {
          value: MenuTypes.Geo,
          text: 'ジオターゲティング',
        },
        {
          value: MenuTypes.Newspaper,
          text: '新聞購読率ターゲティング',
        },
        {
          value: MenuTypes.Pta,
          text: 'PTAターゲティング',
        },
        {
          value: MenuTypes.Automobile,
          text: '自動車ターゲティング',
        },
        {
          value: MenuTypes.Mansion,
          text: 'マンションターゲティング',
        },
        {
          value: MenuTypes.GeoGenome,
          text: 'GeoGenomeターゲティング',
        },
        {
          value: MenuTypes.Railway,
          text: '鉄道ターゲティング',
        },
        {
          value: MenuTypes.Retargeting,
          text: 'リターゲティング',
        },
        {
          value: MenuTypes.CustomGeo,
          text: 'カスタムジオターゲティング',
        },
        {
          value: MenuTypes.Office,
          text: 'オフィスターゲティング',
        },
        {
          value: MenuTypes.Custom,
          text: 'カスタムターゲティング',
        },
      ]
    },
    menuType: {
      get() {
        return this.searchAndFilter.menuType
      },
      set(value) {
        this.onMenuTypeChange(value)
      },
    },
    selectOptions() {
      return [
        { text: '有効', value: 'active' },
        { text: '無効', value: 'inactive' },
      ]
    },
  },
  methods: {
    pagination(pageNo) {
      this.$emit('pagination', pageNo)
    },
    onTextChange(keyword) {
      this.$emit('onTextChange', keyword)
    },
  },
}
</script>

<style scoped>
.checkboxDescription {
  width: 180px;
  padding-top: 24px;
  padding-bottom: 20px;
  font-size: 16px;
  color: #666;
}
.checkbox {
  padding-top: 8px;
  display: inline-block;
  margin-right: 15px;
}
.select {
  max-width: 250px;
  padding-bottom: 10px;
}
.search-box {
  padding-top: 6px;
}
</style>
